import { useEffect,useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import DialogVisualiserDocument from '../../../Components/Dialogs/DialogVisualiserDocument';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { statutDocAdministratifs, typeDocument } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { addTiret, getNomPrenomClearFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
const DocumentAdministratifsEsn = () => {

    const { i18n } = useTranslation();
    const docAdministratifsColumns = [
        {
            field: 'titre',
            title: i18n.t('Type de document'),
            render:  rowData =>
                i18n.t(searchLabelInEnumByValue(typeDocument,rowData?.titre))
        },
        {
            field: 'noDoc',
            title: i18n.t('N° du doc'),
            render: rowData =>
                addTiret(rowData?.noDoc)

        },
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render: rowData => (
                i18n.t(searchLabelInEnumByValue(statutDocAdministratifs,rowData?.statut))
            )

        },
        {
            field: 'esnId_',
            title: i18n.t('Réf.Esn'),

        },
        {
            field: 'nomEsn',
            title: i18n.t('Nom Esn'),

        },
        {
            field: 'dateTelechargement',
            title: i18n.t('Date de téléchargement'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateTelechargement)

        },
        {
            field: 'telechargerPar',
            title: i18n.t('Téléchargé par'),

        },
        {
            field: 'dateValidite',
            title: i18n.t('Date de validité'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateValidite)
        },
    ];

    const [openDialogVisualiserDoc, setOpenDialogVisualiserDoc] = useState(false);
    const [documentAdministratifs, setDocumentAdministratifs] = useState();
    const axiosPrivate = useAxiosPrivate();
    const { setBackdropOpen } = useUtilities();
    const [arrayDocAdministratifs, setArrayDocAdministratifs] = useState([]);
    const [rowSelected,setRowSelected]=useState();
    const [selectedRow, setSelectedRow] = React.useState(null);

    useEffect(() => {
        getDocumentAdministratifs();
    },[]);

    useEffect(() => {
        if(documentAdministratifs?.length > 0){
            console.log('test',documentAdministratifs);
            const Array1 =documentAdministratifs?.map(element => ({
                'id': element?._id,
                'titre': element?.titre,
                //'dateEmission':formatDateJJMMYYYY(element?.createdAt),
                'noDoc':element?.noDoc,
                'url':element?.url,
                'esnId_':element?.esnId?.esnId,
                'nomEsn':element?.esnId?.profileEntreprise?.nom,
                'dateTelechargement':element?.createdAt,
                'telechargerPar':getNomPrenomClearFromPersoData(element?.collaboratorEsnId?.persoData),
                'dateValidite':element?.dateValidite,
                'statut':element?.statut,
                ...element,
            }));

            setArrayDocAdministratifs(Array1.reverse());
        }
    },[documentAdministratifs]);

    const getDocumentAdministratifs = async () => {
        setBackdropOpen(true);
        try {
            console.log('HELLO FROM the get doc adminitratifs a valider Esn useEffect');
            const response = await axiosPrivate.get('/docAdministratif/getEsnsDocsAdministratAValider', {
                // signal: controller.signal
            });
            console.log('response',response.data);
            setDocumentAdministratifs(response.data);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>
            <div className='frame9TableMissionBDCAdmin'>
                <MaterialTableComponent
                    title={i18n.t('Documents administratifs à valider')}
                    columns={docAdministratifsColumns}
                    data={arrayDocAdministratifs}
                    onRowClick={(event, rowData) => {
                        setRowSelected(rowData);
                        setSelectedRow(rowData?.tableData.id);
                        setOpenDialogVisualiserDoc(true);
                    }}
                    // search={false}
                    selectedRow={selectedRow}
                />

                {/*<div>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <MaterialTable
                            icons={tableIcons}

                            options={materialTableOptionsWithoutSearchAndSelection}

                        />
                    </ThemeProvider>
                </div>*/}
            </div>
            <DialogVisualiserDocument
                handleClose={() => {
                    setOpenDialogVisualiserDoc(false);
                }}
                getDocumentAdministratifs={
                    async ()=>{
                        setBackdropOpen(true);
                        try {
                            console.log('HELLO FROM the get doc adminitratifs a valider Esn useEffect');
                            const response = await axiosPrivate.get('/docAdministratif/getEsnsDocsAdministratAValider', {
                                // signal: controller.signal
                            });
                            console.log(response.data);
                            setDocumentAdministratifs(response.data);
                        } catch (error) {
                            console.log(error);
                        }
                        setBackdropOpen(false);
                    }
                }
                document={rowSelected}
                open={openDialogVisualiserDoc}
            />
        </>
    );
};

export default DocumentAdministratifsEsn;